// DynamicDashboard.tsx
import React, { useEffect, useState } from "react";
import { Row, Col, Modal } from "antd";
import { LoadingOutlined, RobotOutlined } from "@ant-design/icons";

import AttendanceReport from "../../feature-module/administration/reports/attendencereport";
import AttendanceSummaryReport from "../../feature-module/administration/reports/attendancesummary";
import Leaveledgerreport from "../../feature-module/administration/reports/leaveledgerreport";
import SalaryReport from "../../feature-module/administration/reports/salaryReport";
import EmployeeReports from "../../feature-module/administration/reports/employeereports";
import HolidayListWidget from "./widgets/HolidayListWidget";
import TeamAttendanceWidget from "./widgets/TeamAttendanceWidget";
import { useLocation } from "react-router-dom";
import LeaveReport from "../../feature-module/administration/reports/leavereport";
import ExportHandler from "../AiActions/ExportHandler";
import OnboardingReport from "../../feature-module/administration/reports/onboardingrepport";
import OffboardingReport from "../../feature-module/administration/reports/offboardingreport";
import TrainingReport from "../../feature-module/administration/reports/trainingreport";
import SkillMatrixReport from "../../feature-module/administration/reports/skillmatrix";
import OverTimeReport from "../../feature-module/administration/reports/overtime_report";
import TimeSheetReport from "../../feature-module/administration/reports/timesheetreport";
import TimeSheetReportlog from "../../feature-module/administration/reports/timesheetlogreport";
import Shift_Report from "../../feature-module/administration/reports/shift_report";
import ProjectReport from "../../feature-module/administration/reports/projectreport";
import TaskReport from "../../feature-module/administration/reports/taskreport";
import UserReports from "../../feature-module/administration/reports/userreports";
import PaySlip from "../../feature-module/finance-accounts/payroll/payslip";
import PayslipReport from "../../feature-module/administration/reports/payslipreport";
import BudgetReport from "../../feature-module/administration/reports/budgetreport";
import ExpensesReport from "../../feature-module/administration/reports/expensereport";
import ESI_Reports from "../../feature-module/administration/reports/ESI_report";
import TDS_Reports from "../../feature-module/administration/reports/tdsreport";
import PF_report from "../../feature-module/administration/reports/PF_report";
import AssetsAllocationReport from "../../feature-module/administration/reports/assetsallocationreport";
import AssetMaintainceReport from "../../feature-module/administration/reports/assetmaintancereport";
import DailyReport from "../../feature-module/administration/reports/dailyreport";
import InvoiceReport from "../../feature-module/administration/reports/invoicereport";
import Holidays from "../../feature-module/hrm/holidays";


const DynamicDashboard = () => {
    const location = useLocation();
    const [componentToRender, setComponentToRender] = useState<React.ReactNode>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showAIAnimation, setShowAIAnimation] = useState(false);

    useEffect(() => {
        if (location.state?.dashboardIntent) {
            loadWidget(location.state.dashboardIntent);
            setIsModalOpen(true);
        }
    }, [location.state]);

    useEffect(() => {
        const handler = (event: any) => {
            loadWidget(event.detail);
            setIsModalOpen(true);
        };

        window.addEventListener("ai-dashboard", handler);
        return () => window.removeEventListener("ai-dashboard", handler);
    }, []);
    useEffect(() => {
        if (isModalOpen) {
            setShowAIAnimation(true);
            const timer = setTimeout(() => {
                setShowAIAnimation(false);
            }, 5000);

            return () => clearTimeout(timer);
        }
    }, [isModalOpen]);

    const loadWidget = (action: any) => {
        const { intent, month, year } = action;
        console.log("action", action)
        switch (intent) {

            case "export_report":
                return setComponentToRender(
                    <ExportHandler
                        reportType={action.reportType}
                        format={action.format}
                        month={action.month}
                        year={action.year}
                        status={action.status}
                        employee={action.employee}
                    />
                );

            case "show_attendance":
                return setComponentToRender(
                    <AttendanceReport
                        dept={action.department}
                        project={action.project}
                        month={month}
                        yearFilter={year}
                        showOnlyTable={true} 
                    />);

            case "show_attendance_summary":
                return setComponentToRender(
                    <AttendanceSummaryReport
                        fromDate={action.fromDate}
                        toDate={action.toDate}
                        month={action.month}
                        year={action.year}
                        employee={action.employee}
                        showOnlyTable={true} 
                    />
                );

            case "show_leave_ledger":
                return setComponentToRender(
                    <Leaveledgerreport
                        employeeFilter={action.employee}
                        departmentFilter={action.department}
                        designationFilter={action.designation}
                        month={action.month}
                        year={action.year}
                        showOnlyTable={true} 
                    />
                );

            case "show_salary":
                return setComponentToRender(<SalaryReport showOnlyTable={true}/>);

            case "show_leave_report":
                return setComponentToRender(
                    <LeaveReport
                        statusFilter={action.status}   // auto apply status
                        year={action.year}
                        showOnlyTable={true} 
                      
                    />
                );

            case "show_salary_by_month":
                return setComponentToRender(<SalaryReport  showOnlyTable={true}/>);

            case "show_employee_count":
                return setComponentToRender(<EmployeeReports
                    status={action.status}
                    department={action.department}
                    project={action.project}
                    showOnlyTable={true} 
                />);

            case "show_holidays":
                return setComponentToRender(<Holidays status={action.status} showOnlyTable={true}/>);

            case "show_team_attendance":
                return setComponentToRender(<TeamAttendanceWidget />);

            case "show_onboarding_report":
                return setComponentToRender(<OnboardingReport status={action.status} showOnlyTable={true} />);

            case "show_offboarding_report":
                return setComponentToRender(<OffboardingReport showOnlyTable={true} />);
            
            case "show_training_report":
                return setComponentToRender(<TrainingReport status={action.status} showOnlyTable={true}  />);

            case "show_skill_matrix_report":
                return setComponentToRender(<SkillMatrixReport showOnlySkillList={true} />
            );

            case "show_over_time_report":
                return setComponentToRender(<OverTimeReport showOnlyTable={true}/>
            );

              case "show_timesheet_report":
                return setComponentToRender(<TimeSheetReport showOnlyTable={true}/>
            );

              case "show_timesheetlog_report":
                return setComponentToRender(<TimeSheetReportlog showOnlyTable={true}/>
            );

               case "show_shift_report":
                return setComponentToRender(<Shift_Report showOnlyTable={true}/>
            );

                case "show_project_report":
                return setComponentToRender(<ProjectReport showOnlyTable={true}/>
            );
                case "show_task_report":
                return setComponentToRender(<TaskReport showOnlyTable={true}/>
            );

                case "show_user_report":
                return setComponentToRender(<UserReports showOnlyTable={true}/>
            );

             case "show_payslip_report":
                return setComponentToRender(<PayslipReport showOnlyTable={true}/>
            );

            case "show_budget_report":
                return setComponentToRender(<BudgetReport showOnlyTable={true}/>
            );
            
            case "show_expenses_report":
                return setComponentToRender(<ExpensesReport showOnlyTable={true}/>
            );

             case "show_esi_report":
                return setComponentToRender(<ESI_Reports/>
            );

              case "show_tds_report":
                return setComponentToRender(<TDS_Reports/>
            );

              case "show_pf_report":
                return setComponentToRender(<PF_report showOnlyTable={true}/>
            );

              case "show_assetsallocation_report":
                return setComponentToRender(<AssetsAllocationReport showOnlyTable={true}/>
            );
             case "show_assetmaintaince_report":
                return setComponentToRender(<AssetMaintainceReport showOnlyTable={true}/>
            );
           
            case "show_daily_report":
             return setComponentToRender(<DailyReport showOnlyTable={true}/>
            );
            case "show_invoice_report":
             return setComponentToRender(<InvoiceReport showOnlyTable={true}/>
            );
             case "generic_report":
                return setComponentToRender(
                    <div style={{ padding: 20 }}>⚠ No exact match found. Please specify report name.</div>
                );


            default:
                return setComponentToRender(null);
        }
    };

const AIAnimation = () => (
    <div style={{ 
        textAlign: 'center', 
        padding: '60px 20px',
        background: 'linear-gradient(135deg, #2c3e50, #4ca1af)',
        borderRadius: '12px',
        color: 'white',
        minHeight: '400px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden'
    }}>
        {/* Particle System */}
        <div className="particle-container">
            {Array.from({ length: 50 }).map((_, i) => (
                <div key={i} className="particle" style={{
                    left: `${Math.random() * 100}%`,
                    animationDelay: `${Math.random() * 5}s`,
                    animationDuration: `${3 + Math.random() * 4}s`
                }} />
            ))}
        </div>

        {/* Wave Animation */}
        <div className="wave-container">
            <div className="wave wave-1"></div>
            <div className="wave wave-2"></div>
            <div className="wave wave-3"></div>
        </div>

        <div style={{ position: 'relative', zIndex: 2 }}>
            {/* Orbital Animation */}
            <div style={{ marginBottom: 40 }}>
                <div className="orbital-system">
                    <div className="central-orb"></div>
                    <div className="orbit orbit-1">
                        <div className="satellite"></div>
                    </div>
                    <div className="orbit orbit-2">
                        <div className="satellite"></div>
                    </div>
                    <div className="orbit orbit-3">
                        <div className="satellite"></div>
                    </div>
                </div>
            </div>

            <h2 style={{ 
                fontSize: '28px', 
                fontWeight: 'bold',
                marginBottom: 16,
                background: 'linear-gradient(45deg, #fff, #a8e6cf)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                color: 'transparent'
            }}>
              Leadchain AI
            </h2>

            <div style={{ 
                fontSize: '16px', 
                marginBottom: 8,
                opacity: 0.9
            }}>
                Gathering insights from data streams...
            </div>

            {/* Progress Rings */}
            <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '30px' }}>
                <div className="progress-ring">
                    <div className="ring ring-1"></div>
                    <div className="ring ring-2"></div>
                    <div className="ring ring-3"></div>
                </div>
            </div>

            <style>
                {`
                .particle-container {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                }

                .particle {
                    position: absolute;
                    width: 4px;
                    height: 4px;
                    background: rgba(255,255,255,0.6);
                    border-radius: 50%;
                    animation: floatUp linear infinite;
                }

                .wave-container {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 100px;
                }

                .wave {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 200%;
                    height: 50px;
                    background: rgba(255,255,255,0.1);
                    border-radius: 50%;
                    animation: waveMove 10s linear infinite;
                }

                .wave-1 { animation-delay: 0s; }
                .wave-2 { animation-delay: -3s; opacity: 0.5; }
                .wave-3 { animation-delay: -6s; opacity: 0.3; }

                .orbital-system {
                    position: relative;
                    width: 120px;
                    height: 120px;
                    margin: 0 auto;
                }

                .central-orb {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    width: 30px;
                    height: 30px;
                    background: #ff6b6b;
                    border-radius: 50%;
                    transform: translate(-50%, -50%);
                    box-shadow: 0 0 20px #ff6b6b;
                    animation: centralPulse 2s ease-in-out infinite;
                }

                .orbit {
                    position: absolute;
                    border: 1px solid rgba(255,255,255,0.3);
                    border-radius: 50%;
                }

                .orbit-1 {
                    top: 10%;
                    left: 10%;
                    right: 10%;
                    bottom: 10%;
                    animation: rotate 8s linear infinite;
                }

                .orbit-2 {
                    top: 20%;
                    left: 20%;
                    right: 20%;
                    bottom: 20%;
                    animation: rotate 12s linear infinite reverse;
                }

                .orbit-3 {
                    top: 30%;
                    left: 30%;
                    right: 30%;
                    bottom: 30%;
                    animation: rotate 16s linear infinite;
                }

                .satellite {
                    position: absolute;
                    width: 8px;
                    height: 8px;
                    background: #4ecdc4;
                    border-radius: 50%;
                    top: -4px;
                    left: 50%;
                    transform: translateX(-50%);
                    box-shadow: 0 0 8px #4ecdc4;
                }

                .progress-ring {
                    position: relative;
                    width: 80px;
                    height: 80px;
                }

                .ring {
                    position: absolute;
                    border: 2px solid transparent;
                    border-top: 2px solid #fff;
                    border-radius: 50%;
                    animation: spin 2s linear infinite;
                }

                .ring-1 {
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    animation-delay: 0s;
                }

                .ring-2 {
                    top: 10px;
                    left: 10px;
                    right: 10px;
                    bottom: 10px;
                    animation-delay: 0.2s;
                    animation-duration: 1.5s;
                }

                .ring-3 {
                    top: 20px;
                    left: 20px;
                    right: 20px;
                    bottom: 20px;
                    animation-delay: 0.4s;
                    animation-duration: 1s;
                }

                @keyframes floatUp {
                    0% {
                        transform: translateY(100%) scale(0);
                        opacity: 0;
                    }
                    50% {
                        opacity: 1;
                    }
                    100% {
                        transform: translateY(-100%) scale(1);
                        opacity: 0;
                    }
                }

                @keyframes waveMove {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-50%); }
                }

                @keyframes rotate {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }

                @keyframes centralPulse {
                    0%, 100% { transform: translate(-50%, -50%) scale(1); }
                    50% { transform: translate(-50%, -50%) scale(1.1); }
                }

                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                `}
            </style>
        </div>
    </div>
);

    return (
        <>
        <Row gutter={[20, 20]}>
            {/* {componentToRender && (
                <Col xs={24} sm={24} md={24} lg={24}>
                    {componentToRender}
                </Col>
            )} */}
            AI Result
        </Row>
        <Modal
        open={isModalOpen}
        onCancel={() => { setIsModalOpen(false); setShowAIAnimation(false) }}
        footer={null}
        width="100%"
        style={{ top: 20,}}
        zIndex={1100}
      >
       {showAIAnimation ? (
                    <AIAnimation />
                ) : (
                    componentToRender || (
                        <div style={{ textAlign: "center", color: "#888", padding: '40px' }}>
                            No report loaded yet.
                        </div>
                    )
                )}
        </Modal>
      </>
    );
};

export default DynamicDashboard;
